import { createAsyncThunk } from "@reduxjs/toolkit";
import { type RevealedNationalId } from "../../../domain/entities/compliance";
import { type ComplianceDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const revealNationalId = createAsyncThunk<
  RevealedNationalId,
  { requestId: string },
  { dispatch: ComplianceDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.REVEAL_NATIONAL_ID, async ({ requestId }, { extra }) => {
  return await extra.complianceRepo.revealNationalId(requestId);
});
